import { defineMessages } from 'react-intl';

export const messages = defineMessages({
    namePlaceholder: {
        id: 'pdpDealerDetailsMessages.name_placeholder',
        defaultMessage: 'Name',
    },
});
